import React, { useCallback, useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { useDispatch } from "react-redux";
import FormikInput from "src/components/formik/FormikInput";
import { PAYMENT_MODE_TYPES_LIST } from "../product-container/ProductConstants";
import FormikSelect from "src/components/formik/FormikSelect";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import { casePaymentCreateAPI, caseReceiptCreateAPI, caseUpdateAPI } from "src/api/CaseApi";
import { headerShowAction } from "../header-container/actions/HeaderActions";
import Table from "src/components/table/Table";
import UsePermission from "src/hoc/UsePermission";
import { includeStamp } from "src/utils/StampUtils";
import { cloneDeep } from "lodash";
import { caseUpsertAction } from "../case-container/actions/CaseActions";

const Render = (props) => {
  const {
    dueAmountModalClass,
    dueAmountDisplay,
    closeAlertDialog,
    type,
    values,
    permission,
    removePayment,
    payments
  } = props;
  return (
    <Form>
      <div
        className={`modal fade ${dueAmountModalClass}`}
        id="authAlert"
        style={{
          display: `${dueAmountDisplay}`,
          overflowY: "scroll",
          opacity: "1",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {(type == "rec") ? "Receipt - Bank Payment" : "Payment - Agent Payout"}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeAlertDialog((type == "rec") ? "dueAmount" : "Payout")}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="form-group col-md-12">
                  <label>Due Amount</label>
                  <FormikInput
                    name="ReceiptDue"
                    type="text"
                    // placeholder="0"
                    value={values.ReceiptDue}
                    className="form-control"
                    disabled
                  />
                  {(type !== "rec") ?  
                  <>
                   <label>Advance Payment Amount</label>
                  <FormikInput
                  name="advanceBalance"
                  type="text"
                  disabled
                  placeholder={"Advance Balance"}
                  className="form-control"
                  value={values.totalAdvanceAmount}
                /> 
                </>
                : ""}
                {(type !== "rec") ?  
                  <>
                 <label>Remaining Amount</label>
                 <FormikInput
                  name="remaningAmount"
                  type="text"
                  disabled
                  placeholder={"remaningAmount"}
                  className="form-control"
                  value={values.remainingPayOut}
                />
                </>
                : ""}
                </div>
                <div className="form-group col-md-12">
                <label> {(type == "rec") ? "Received till now" : "Paid till now"}</label>
                  <FormikInput
                    name="receivedTill"
                    type="text"
                    value={values.receivedTill}
                    placeholder="0"
                    className="form-control"
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="modal-body">
              <div className="form-group col-md-12">
                <FormikInput
                  name="amount"
                  type="text"
                  placeholder={(type == "rec") ? "Received Amount" : "Enter Amount to be paid"}
                  className="form-control"
                  value={values.amount}
                />
                <label>Mode of Payment</label>
                <FormikSelect
                  items={PAYMENT_MODE_TYPES_LIST}
                  name="mode"
                  className="form-control"
                />
                {/* <Field
                  type="text"
                  className="form-control"
                  disabled
                  value="NEFT_RTGS"
                  name="mode"
                  initialValue="NEFT_RTGS"
                /> */}
                <FormikInput
                  name="instrument_number"
                  type="text"
                  placeholder="Transaction/Ref. No."
                  className="form-control my-2"
                />
                <label>Payment Date</label>
                <FormikDateTimePicker
                  name="date"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeAlertDialog((type == "rec") ? "dueAmount" : "Payout")}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary"
              >
               {(type == "rec") ? "Submit" : "Pay"}
              </button>
              <hr />
            </div>
            <div className="card mt-3">
              <div className="card-body">
                <h5 className="card-title">Payments</h5>
                <Table
                  hasRemove={permission}
                  removeClick={removePayment}
                  rowDeletedCheckPath="deleted"
                  recordsPerPage={4}
                  searchData={{
                    data: payments?.data,
                    count: payments?.count,
                    currentPage: 0,
                  }}
                  columns={{
                    payment_date: {
                      display: 'Payment Date',
                      path: 'date',
                    },
                    instrument_number: {
                      display: 'Number',
                      path: 'number',
                    },
                    amount: {
                      display: 'Amount',
                      path: 'amount',
                    },
                    deletedTs: {
                      display: 'Deleted On',
                      path: 'deletedTs',
                    },
                    deletedBy: {
                      display: "Deleted By",
                      path: "updatedBy.personalInfo.firstName",
                    }
                  }}
                />
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </Form>
  )

}

const PayRecPopup = (props) => {
  // REDUX
  const dispatch = useDispatch();
  const initialValues = {
    ReceiptDue: props.totalCheckedDue || 0,
    receivedTill: props.totalReceived || 0,
    advanceBalance: props?.totalAdvanceAmount || 0,
    remaningAmount: props?.remainingPayOut || 0,
  }

  const { 
    closeAlertDialog,
    pendingAmountList, 
    caseForPayRec, 
    handleSubmitUpdates 
  } = props;
  const [payments, setPayments] = useState({})

  useEffect(() => {
    if (props.type == 'rec') {

      createPayments(caseForPayRec?.recieptDetails)
    } else {
      createPayments(caseForPayRec?.paymentDetails)
    }
  }, [closeAlertDialog, props])


  const createPayments = (paymentsData) => {
    // Check if paymentsData is an array
    if (Array.isArray(paymentsData)) {
      const updatedPaymentsData = paymentsData.map(payment => {
        // Create a new object to avoid mutating the original object
        const updatedPayment = { ...payment };

        // Rename the property based on the props.type
        if (props.type === 'rec') {
          updatedPayment.number = updatedPayment.rec_no;
        } else {
          updatedPayment.number = updatedPayment.instrument_number;
          delete updatedPayment.instrument_number;
        }

        return updatedPayment;
      });

      const payments = { data: updatedPaymentsData, count: updatedPaymentsData.length };
      setPayments(payments);
    } else {
      return { error: 'Invalid payments data. Must be an array.' };
    }
  };

  const viewComissionPaymentsPermissionRemove = UsePermission({
    scope: 'reports.payout_calculation.commission_payments.remove',
  });

  const onSubmit = useCallback((
    values,
    formikUtils
  ) => {
    if (values.remaningAmount != values.amount) {
      alert("The received Amount should be equal to pending amount.")
      return
    }
    formikUtils.setSubmitting(false);
    props.invoiceInitialValues.forEach((caseId) => {
      const pendingAmount = pendingAmountList.filter((pending) => caseId === pending.id)
      const PayloadData = {
        _id: caseId,
        values: { ...values, amount: pendingAmount[0]?.amount || values.ReceiptDue }
      }
      if (props.type == "rec")
        caseReceiptCreateAPI(caseId, { ...PayloadData })
      else{
        casePaymentCreateAPI(caseId, { ...PayloadData })
        handleSubmitUpdates(values);
      }
    })
    closeAlertDialog((props.type == "rec") ? "dueAmount" : "Payout")

    dispatch(
      headerShowAction({
        data: `${(props.type == "rec") ? "Receipt" : "Payment"} updated successfully`,
      })
    )
  }, [props, closeAlertDialog])

  const removePayment = (record) => {
    const newRecord = cloneDeep(props.caseForPayRec)

    if (props.type == "rec") {
      newRecord.recieptDetails.find((receipt) => {
        if (record._id === receipt._id) {
          // eslint-disable-next-line no-param-reassign
          receipt.deleted = true;
          // eslint-disable-next-line no-param-reassign
          receipt.deletedTs = new Date();
          includeStamp(receipt);
          return true;
        }

        return false;
      });
    } else {
      newRecord.paymentDetails.find((receipt) => {
        if (record._id === receipt._id) {
          // eslint-disable-next-line no-param-reassign
          receipt.deleted = true;
          // eslint-disable-next-line no-param-reassign
          receipt.deletedTs = new Date();
          includeStamp(receipt);
          return true;
        }

        return false;
      });
    }


    dispatch(caseUpsertAction(newRecord));
  };
  return (
    <Formik
      onSubmit={onSubmit}
      // onClear={onClear}
      enableReinitialize
      initialValues={initialValues}
    // validationSchema={}
    >
      {(formikProps) => (
        <Render
          onSubmit={onSubmit}
          {...formikProps}
          {...props}
          permission={viewComissionPaymentsPermissionRemove}
          removePayment={removePayment}
          payments={payments}
        />
      )}
    </Formik>
  )
}
export default PayRecPopup;